import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ntc-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  listaGraficos = [];

  contratosInadimplentes = [
    {
      Referencia: 'Adimplente',
      Valor: 80
    },
    {
      Referencia: 'Inadimplente',
      Valor: 20
    }
  ];

  atendimentosPorCanal = [
    {
      Referencia: 'Loja',
      Valor: 38
    },
    {
      Referencia: 'Telefone',
      Valor: 40
    },
    {
      Referencia: 'Aplicativo',
      Valor: 10
    },
    {
      Referencia: 'E-mail',
      Valor: 10
    },
    {
      Referencia: 'Outros',
      Valor: 2
    }
  ];

  contratosLigadosPorServico = [
    {
      Referencia: 'Somente TV',
      Valor: 10
    },
    {
      Referencia: 'Somente NET',
      Valor: 12
    },
    {
      Referencia: 'TV + NET',
      Valor: 28
    },
    {
      Referencia: 'TV + NET + TEL',
      Valor: 28
    },
    {
      Referencia: 'NET + TEL',
      Valor: 20
    },
    {
      Referencia: 'Outros',
      Valor: 2
    }
  ];

  resultadoFiliais = [
    {
      Ano: 2014,
      saoluis: 20,
      santaines: 0,
      canoas: 10,
      esteio: 5,
      saoleopoldo: 2
    },
    {
      Ano: 2015,
      saoluis: 22,
      santaines: 0,
      canoas: 12,
      esteio: 3,
      saoleopoldo: 4
    },
    {
      Ano: 2016,
      saoluis: 21,
      santaines: 2,
      canoas: 12,
      esteio: 2,
      saoleopoldo: 6
    },
    {
      Ano: 2017,
      saoluis: 25,
      santaines: 3,
      canoas: 13,
      esteio: 3,
      saoleopoldo: 10
    }
  ];

  constructor() {
    /*
       ModeloGrafico 1 ('pie' | 'doughnut' | 'donut')
       ModeloGrafico 2 ('bar')
       ModeloGrafico 3 ('line' | 'stackedline' | 'fullstackedline' | 'area' | 'stackedarea' |
                        'fullstackedarea' | 'spline' | 'splinearea' | 'scatter' )
    */
    this.listaGraficos = [
      {
        Title: 'Contratos Ligados',
        Subtitle: '',
        Dados: this.contratosLigadosPorServico,
        ModeloGrafico: '1',
        Palette: 'bright',
        Type: 'doughnut',
        ArgumentField: 'Referencia',
        ValueField: 'Valor'
      },
      {
        Title: 'Contratos Inadimplentes',
        Subtitle: '',
        Dados: this.contratosInadimplentes,
        ModeloGrafico: '1',
        Palette: 'bright',
        Type: 'pie',
        ArgumentField: 'Referencia',
        ValueField: 'Valor'
      },
      {
        Title: 'Atendimentos',
        Subtitle: 'Por canal',
        Dados: this.atendimentosPorCanal,
        ModeloGrafico: '2',
        Palette: 'bright',
        Type: 'bar',
        ArgumentField: 'Referencia',
        ValueField: 'Valor'
      },
      {
        Title: 'Resultado por Filial',
        Subtitle: 'Faturamento mensal',
        Dados: this.resultadoFiliais,
        ModeloGrafico: '3',
        Palette: 'bright',
        Type: 'line',
        ArgumentField: 'Ano',
        ValueField: 'Valor',
        Series: [
          {
            ValueField: 'saoluis',
            Name: 'São Luís - MA'
          },
          {
            ValueField: 'santaines',
            Name: 'Santa Inês - MA'
          },
          {
            ValueField: 'canoas',
            Name: 'Canoas - RS'
          },
          {
            ValueField: 'esteio',
            Name: 'Esteio - RS'
          },
          {
            ValueField: 'saoleopoldo',
            Name: 'São Leopoldo - RS'
          }
        ]
      }
    ];
  }

  ngOnInit() {
  }

  pointClickHandler(e) {
    this.toggleVisibility(e.target);
  }

  legendClickHandler (e) {
    const arg = e.target;
    const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];

    this.toggleVisibility(item);
  }

  toggleVisibility(item) {
    if (item.isVisible()) {
        item.hide();
    } else {
        item.show();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts